declare namespace $ {

	type $mol_check_icon__sub_shm_hitalama_speech_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check_icon['sub'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_speech_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_speech['Toggle_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_shm_hitalama_speech_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_speech['hearing'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	export class $shm_hitalama_speech extends $mol_view {
		Enabled( ): $mol_speck
		enabled_visible( ): readonly(any)[]
		Toggle_icon( ): $mol_icon_microphone
		hearing( next?: boolean ): boolean
		Toggle( ): $mol_check_icon
		Picker( ): $shm_hitalama_speech_picker
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=speech.view.tree.d.ts.map